import './headline.css';

export interface HeadlineProps {
    classname?: string,
    text: string;
}

export function H2(props: HeadlineProps): JSX.Element {
    return <h2 className={props.classname}>{props.text.toUpperCase()}</h2>
}

export function H3(props: HeadlineProps): JSX.Element {
    return <h3 className={props.classname}>{props.text.toUpperCase()}</h3>
}

export function H4(props: HeadlineProps): JSX.Element {
    return <h4 className={props.classname}>{props.text.toUpperCase()}</h4>
}